const CATEGORY_IDS = {
  X_TEAM_EVENTS: 1,
  TECH_GADGETS: 2,
  ENTERTAINMENT: 4,
  HEALTH_WELLNESS: 5,
  ACTIVE_LIFESTYLE: 6,
  HOME_DECOR: 7,
  OUTDOOR_ADVENTURES: 8,
  FAMILY_KIDS_FRIENDS: 9,
  FOOD_DRINKS: 10,
  LEARNING: 14,
} as const;

// Claim suggestions mapped to category IDs
export const CLAIM_SUGGESTIONS: {
  text: string;
  categoryId: (typeof CATEGORY_IDS)[keyof typeof CATEGORY_IDS];
}[] = [
  {
    text: "Go get those AirPods you've been eyeing. Future-you will thank you.",
    categoryId: CATEGORY_IDS.TECH_GADGETS,
  },
  {
    text: 'That Outpost in Thailand looks unreal. Book the flights.',
    categoryId: CATEGORY_IDS.X_TEAM_EVENTS,
  },
  { text: 'Upgrade your workspace. New chair. New energy.', categoryId: CATEGORY_IDS.HOME_DECOR },
  {
    text: "Weekend away? Lock it in. You've earned it.",
    categoryId: CATEGORY_IDS.OUTDOOR_ADVENTURES,
  },
  {
    text: 'That gym membership you keep thinking about? Start.',
    categoryId: CATEGORY_IDS.ACTIVE_LIFESTYLE,
  },
  {
    text: 'Noise-cancelling headphones = productivity unlocked.',
    categoryId: CATEGORY_IDS.TECH_GADGETS,
  },
  {
    text: 'Take your partner out somewhere that requires reservations.',
    categoryId: CATEGORY_IDS.FOOD_DRINKS,
  },
  { text: 'Invest in that online course. Skill up.', categoryId: CATEGORY_IDS.LEARNING },
  { text: 'Book the massage. Yes, the long one.', categoryId: CATEGORY_IDS.HEALTH_WELLNESS },
  { text: 'Surprise the kids with something epic.', categoryId: CATEGORY_IDS.FAMILY_KIDS_FRIENDS },
  { text: 'Buy the running shoes. Then use them.', categoryId: CATEGORY_IDS.ACTIVE_LIFESTYLE },
  {
    text: "Plan the boys' trip. Stop talking about it.",
    categoryId: CATEGORY_IDS.OUTDOOR_ADVENTURES,
  },
  {
    text: 'Upgrade your coffee setup. Barista mode: activated.',
    categoryId: CATEGORY_IDS.FOOD_DRINKS,
  },
  { text: 'Finally replace that cracked screen.', categoryId: CATEGORY_IDS.TECH_GADGETS },
  {
    text: 'Book the concert tickets before they sell out.',
    categoryId: CATEGORY_IDS.ENTERTAINMENT,
  },
];
